module.exports = __webpack_public_path__ + "static/media/key.44921d02.png";